import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import '@teamhive/lottie-player';
import {
    BlogHomeCardsComponent,
    BotaoFavoritarComponent,
    CapgoUpdateBannerComponent,
    CardGenericoComponent,
    CardTabelaComponent,
    CardTabelaShellComponent,
    ComunicadoCardComponent,
    ConteudoBloqueadoComponent,
    CopaMatchesCardComponent,
    CopaMatchesModalComponent,
    CopaSplashComponent,
    CopaTabBallComponent,
    CotacaoFloatingWidgetComponent,
    DicasRmsComponent,
    EmptyScreenComponent,
    EmptyStateComponent,
    FooterComponent,
    HeaderCustomComponent,
    LogoComponent,
    LottiesComponent,
    MenuListComponent,
    MenuTabelasComponent,
    ModalComunicadoComponent,
    ModalCustomComponent,
    ModalDetailPropagrandaComponent,
    ModalFiltroComponent,
    ModalPermissionsComponent,
    ModalPhotoviewerComponent,
    ModalQrScannerComponent,
    NotificacoesListComponent,
    NotificationsModalComponent,
    PDFDownloadProgressComponent,
    PdfPreviewModalComponent,
    PopoverComponent,
    PropagandaParceirosComponent,
    QuoteSummaryBubbleComponent,
    SemConexaoTrexComponent,
    SharingActionsInstagramStyleComponent,
    SheetPropagandaParceiroComponent,
    SinalAlertaPiscandoComponent,
    SyncStatusComponent,
    UserdetailsComponent,
    VestingStatusBadgeComponent,
} from '.';

import { PinchZoomModule } from '@mapaxe/ngx-pinch-zoom';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ShellModule } from 'src/app/shell/shell.module';
import { ImgFallbackDirective } from '../directives';
import { CategoriasMenuComponent } from './categorias/categorias-menu.component';

const componentsSharedModules = [
    BlogHomeCardsComponent,
    BotaoFavoritarComponent,
    CardGenericoComponent,
    LogoComponent,
    HeaderCustomComponent,
    LottiesComponent,
    MenuTabelasComponent,
    ModalCustomComponent,
    ModalDetailPropagrandaComponent,
    ModalPhotoviewerComponent,
    NotificacoesListComponent,
    NotificationsModalComponent,
    PopoverComponent,
    PropagandaParceirosComponent,
    SemConexaoTrexComponent,
    CotacaoFloatingWidgetComponent,
    SheetPropagandaParceiroComponent,
    SinalAlertaPiscandoComponent,
    SyncStatusComponent,
    UserdetailsComponent,
    CardTabelaComponent,
    ModalFiltroComponent,
    EmptyStateComponent,
    ModalComunicadoComponent,
    ComunicadoCardComponent,
    MenuListComponent,

    FooterComponent,
    LogoComponent,
    SharingActionsInstagramStyleComponent,
    DicasRmsComponent,
    EmptyScreenComponent,
    PDFDownloadProgressComponent,
    PdfPreviewModalComponent,
    ModalPermissionsComponent,
    CardTabelaShellComponent,
    ModalQrScannerComponent,
    ConteudoBloqueadoComponent,
    CapgoUpdateBannerComponent,
    QuoteSummaryBubbleComponent,
    CopaSplashComponent,
    CopaTabBallComponent,
    CopaMatchesCardComponent,
    CopaMatchesModalComponent,
    VestingStatusBadgeComponent,
];
@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        PipesModule,
        ShellModule,
        PinchZoomModule,
        CategoriasMenuComponent,
    ],
    exports: [...componentsSharedModules, PipesModule],
    declarations: [...componentsSharedModules, ImgFallbackDirective],
})
export class ComponentsModule {}
